import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import _Button from "../../../../generic/_Button";
import _Badge from "../../../../generic/_Badge";
import _Input from "../../../../generic/_Input";
import _Select from "../../../../generic/_Select";
import ModalAction from "../../../../modal/ModalAction";
import OptionLabelsSelector from "../../../OptionLabelsSelector";
import { ErrorMessage, SuccessMessage } from "../../../../../utils/toastify";
import Icon from "../../../../Icon";
import { useAuth } from "../../../../../Context/AuthContext";
import PropTypes from "prop-types";
import useAdvanceRCS from "../../../hooks/useAdvanceRcs";
import MediaUpload from "../../../MediaUpload";
import axios from "axios";
import { FILES_SERVICE_URL } from "../../../../../utils/ApiEndpoint";
const MediaActions = (props) => {
  const auth = useAuth();
  let { token } = auth.getSessionData();
  const { carrousel = null } = props;
  /* eslint-disable no-unused-vars */
  const { values, setFieldValue, errors, handleChange, handleBlur } =
    useFormikContext();
  const [show, setShow] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedTypeFile, setSelectedTypeFile] = useState("");

  const { basePath, currentValues } = useAdvanceRCS({
    key: "imageUrl",
    carrousel: carrousel,
    values: values,
  });

  const { basePath: basePathThumbnail } = useAdvanceRCS({
    key: "thumbnail_url",
    carrousel: carrousel,
    values: values,
  });
  useEffect(() => {
    if (isUpload && !currentValues) {
      handleCleanUpload();
    }
  }, [values.step]);

  const getFieldErrors = () => {
    if (carrousel !== null) {
      return errors?.carrousel?.[carrousel]?.imageUrl;
    }

    return errors?.imageUrl;
  };

  const handleUploadImage = async () => {
    setLoading(true);
    if (!previewUrl) {
      ErrorMessage("Por favor, seleccione un archivo para subir");
      return;
    }

    const buffer = await file.arrayBuffer();
    const file_content = btoa(
      new Uint8Array(buffer).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        "",
      ),
    );

    const data = {
      type_file: file.type,
      file: file_content,
      name: file.name || `file-${Date.now()}`,
    };

    try {
      const response = await axios.post(FILES_SERVICE_URL, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.status !== 200) {
        throw new Error("Error al subir la imagen");
      }
      setFieldValue(basePath, response?.data?.data?.uri);
      setFieldValue(basePathThumbnail, response?.data?.data?.thumbnail);

      setShow(false);
      SuccessMessage("Archivo agregado con éxito");
    } catch (error) {
      ErrorMessage(`Ha ocurrido un error, fallo al subir el archivo`);
    } finally {
      setLoading(false);
    }
  };

  const _onClose = () => {
    setShow(false);
  };

  const handleCleanUpload = () => {
    setPreviewUrl(null);
    setFile(null);
    setIsUpload(!isUpload);
    setFieldValue(basePath, "");
  };

  useEffect(() => {
    if (selectedTypeFile) {
      setPreviewUrl(null);
      setFile(null);
      setFieldValue(basePath, "");
    }
  }, [selectedTypeFile]);

  const isDisabled = () => {
    let disabled = false;

    if (!isUpload) {
      disabled = errors && !!getFieldErrors();
    } else if (isUpload) {
      disabled = !file || !previewUrl;
    }

    return disabled;
  };

  const validUrlByType = () => {
    const url = String(currentValues);
    const clean = url.split("?")[0].toLowerCase();

    const dot = clean.lastIndexOf(".");
    if (dot === -1) return false;

    const ext = clean.slice(dot);

    if (selectedTypeFile === "image") {
      return [".png", ".jpg", ".jpeg", ".gif"].includes(ext);
    }

    if (selectedTypeFile === "pdf") {
      return ext === ".pdf";
    }

    return false;
  };

  const renderFileUploader = () => {
    const configs = {
      image: {
        title: "Añadir URL de la imagen",
        icon: "add_photo_alternate",
        placeholder: "https://ejemplo.com/imagen.jpg",
        uploadTitle: "Selecciona una imagen para subir",
        uploadAccept: "image/png, image/jpeg, image/gif, image/jpg",
        uploadButton: "Subir Imagen",
        previewComponent: (url) =>
          !url ? (
            <div className="flex flex-col items-center justify-center rounded-lg border-2 border-gray-300 border-dashed border-border p-8 text-center max-h-[300px]">
              <Icon icon="image" />
              <span className="text-gray-600">Preview de la imagen </span>
            </div>
          ) : (
            <img
              src={url}
              alt="Preview"
              className="h-auto w-full rounded-md object-contain"
              style={{ maxHeight: "300px" }}
              onError={(e) => {
                e.target.src =
                  "https://d1x6nshzzr4pih.cloudfront.net/files/images/308a5bb3-fc10-4963-ab68-c0d19d4cb5fb.jpg";
              }}
            />
          ),
      },
      pdf: {
        title: "Añadir URL del PDF",
        icon: "pdf",
        uploadTitle: "Selecciona un PDF para subir",
        uploadButton: "Subir PDF",
        uploadAccept: "application/pdf",
        placeholder: "https://ejemplo.com/documento.pdf",
        previewComponent: (url) =>
          !url ? (
            <div className="flex flex-col items-center justify-center rounded-lg border-2 border-gray-300 border-dashed border-border p-8 text-center max-h-[300px]">
              <Icon icon="attachment" />
              <span className="text-gray-600"> No se ha cargado un PDF </span>
            </div>
          ) : (
            <div className="flex items-center justify-center">
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-100 hover:bg-gray-400 hover:text-white text-gray-600 py-2 px-4 rounded-md flex items-center gap-2 justify-center w-[200px] no-underline"
              >
                <Icon icon="picture_as_pdf" className={"hover:text-white"} />
                <span className="text-md font-semibold ">PDF</span>
              </a>
            </div>
          ),
      },
    };

    const config = configs[selectedTypeFile];
    if (!config) return null;

    if (isUpload)
      return (
        <MediaUpload
          selectedTypeFile={selectedTypeFile}
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
          file={file}
          setFile={setFile}
          config={config}
        />
      );

    return (
      <>
        <_Input
          title={config.title}
          name="imageUrl"
          id="imageUrl"
          type="text"
          placeholder={config.placeholder}
          value={currentValues}
          onChange={(e) => {
            setFieldValue(basePath, e.target.value);
          }}
          onBlur={handleBlur}
          isError={!!getFieldErrors() || !validUrlByType()}
          errors={
            getFieldErrors() || !validUrlByType()
              ? "URL inválida no soportada"
              : ""
          }
          required
        />

        {config.previewComponent(currentValues)}
      </>
    );
  };

  return (
    <>
      <_Badge count={currentValues ? 1 : 0}>
        <_Button
          icon="attach_file"
          style="none"
          className="w-full"
          title="Archivo"
          onClick={() => setShow(true)}
        />
      </_Badge>
      <ModalAction
        title="Agregar archivo multimedia"
        onClose={() => setShow(false)}
        visible={show}
      >
        <div className="space-y-2">
          <OptionLabelsSelector
            options={[
              {
                label: "Agregar URL del archivo multimedia",
                value: false,
              },
              {
                label: "Subir archivo multimedia",
                value: true,
              },
            ]}
            value={isUpload}
            onChange={handleCleanUpload}
          />

          <_Select
            title="Tipo de archivo multimedia"
            value={selectedTypeFile}
            onChange={(e) => setSelectedTypeFile(e.target.value)}
            options={[
              {
                label: "Selecciona el tipo de archivo",
                value: "",
              },
              {
                label: "Imagen",
                value: "image",
              },
              {
                label: "PDF",
                value: "pdf",
              },
            ]}
          />

          {renderFileUploader()}
        </div>
        <div className="p-3 bg-white">
          <div className="mt-3 flex justify-end gap-2 pt-3">
            <_Button
              title="Cancelar"
              style="none"
              type="button"
              onClick={_onClose}
              loading={loading}
            />
            <_Button
              style="primary"
              title="Guardar"
              disabled={isDisabled() || !isUpload ? !validUrlByType() : false}
              onClick={() => {
                !isUpload ? _onClose() : handleUploadImage();
              }}
              loading={loading}
            />
          </div>
        </div>
      </ModalAction>
    </>
  );
};
MediaActions.propTypes = {
  carrousel: PropTypes.any,
};
export default MediaActions;
